import { AsyncPipe, SlicePipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  output,
} from '@angular/core';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'tax-with-status',
  templateUrl: './tax-with-status.component.html',
  styleUrls: ['./tax-with-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TagModule, AsyncPipe, SlicePipe],
})
export class TaxWithStatusComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject(null);
  keyName!: string;
  additionData: Observable<any> = new BehaviorSubject(null);
  readonly onAction = output<{ action: string; columnData: any }>();
  isFuture = false;
  value!: any;

  constructor() {}

  ngOnInit(): void {
    this.columnData.subscribe((res: any) => {
      const seconds = Math.floor(
        (+new Date() - +new Date(res.start_date)) / 1000,
      );
      if (seconds < 0) this.isFuture = true;
    });
  }

  executeAction(action: string, columnData: any) {
    this.onAction.emit({ action, columnData: columnData });
  }
}
